import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, TemplateRef} from '@angular/core';
import {Observable} from 'rxjs';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule} from '@angular/forms';

export interface ContentView {
  id: 'filter' | 'results' | 'create' | 'edit';
  label: string;
  visible$: Observable<boolean>;
}

@Component({
    selector: 'lib-input-content-view',
    imports: [CommonModule],
    templateUrl: './input-content-view.component.html',
    styleUrls: ['./input-content-view.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputContentViewComponent implements OnInit {

  @Input() selected: ContentView['id'] = 'results';
  @Input() views: ContentView[] = [];

  @Input() resultTemplate!: TemplateRef<any>;
  @Input() editTemplate!: TemplateRef<any>;
  @Input() createTemplate!: TemplateRef<any>;

 @Output() selectedChange = new EventEmitter<ContentView['id']>();

  constructor() { }

  ngOnInit(): void {
  }

}
